// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"a328ef44","3450":"e8f74b77","6889":"2158ed13","7377":"631db1ff","8777":"894f71d8"}[chunkId] + ".chunk.css";
};